import { IPlayer } from "@grassrootly/api/entities";
import { UpdatePlayerPayload } from "@grassrootly/api/gateways";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { decode } from "base64-arraybuffer";

export const UpdatePlayer = async (params: UpdatePlayerPayload): Promise<IPlayer> => {
  const player = withErrorCheck(await server.from("Players").select().eq("id", params.id))[0];
  if (!player) {
    throw new Error("Player not found.");
  }
  let profilePic = player.profile_picture;
  if (params.paylod.has("image")) {
    const newImage: { uri: string; name: string; contentType: string; base64: string } = JSON.parse(
      params.paylod.get("image") as string
    );
    const { data } = await server.storage
      .from("profile_pics")
      .upload(`players/${player.id}/${newImage.name}`, decode(newImage.base64), {
        contentType: newImage.contentType,
        upsert:true
      });
    if (data && data.path) {
      const { data: publicData } = server.storage
        .from("profile_pics")
        .getPublicUrl(`players/${player.id}/${newImage.name}`);
      if (publicData && publicData) {
        profilePic = publicData.publicUrl;
      }
    }
  }
  const name = params.paylod.get("name") as string;

  return withErrorCheck(
    await server
      .from("Players")
      .update({ name: name || player.name, profile_picture: profilePic })
      .eq("id", player.id)
      .select()
  )[0];
};
